<template>
  <div v-if="applyData" class="report_layout clearfix"
    :class="{
      'lnb-minimize': $store.state.layout.lnbMinimize,
      'gnb-minimize': $store.state.layout.gnbMinimize
    }">
    <report-menu/>
    <report-header/>
    <page-list v-if="showReportPageList"
      @onPageClick="onPageClick"/>

    <router-view class="content"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ReportHeader from '@/components/header/ReportHeader'
import ReportMenu from '@/components/report/ReportMenu'
import PageList from '@/components/header/PageList'

export default {
  components: {
    ReportHeader,
    ReportMenu,
    PageList
  },
  computed: {
    ...mapState([
      'userData',
      'applyData',
      'showReportPageList'
    ])
  },
  methods: {
    ...mapMutations([
      'setShowReportPageList'
    ]),
    onPageClick (item) {
      const params = {
        aid: item.aid
      }

      // todo: check usage
      // if (this.userData.creditEmpty) {
      //   query.creditEmpty = true
      // }

      this.$router.push({
        params,
        name: 'heatmap-report'
      })
      this.setShowReportPageList(false)
    }
  }
}
</script>

<style>

</style>
